import {getSaveJobData} from "./saveJobData";
import {postSaveJob, postScheduleAppointment} from "../api/job-api";
import {getSaveAppointmentData} from "./saveAppointmentData";
import {registerUser, updateUser} from "../api/user";
import {setRegisteredUserData, setUserInfo} from "../userLogic/userActions";

export const SET_LOADING = "SET_LOADING";
export const EXPAND_FOOTER_INFO = "EXPAND_FOOTER_INFO";
export const SET_LEAD_POPUP = "SET_LEAD_POPUP";
export const ALLOW_SAVING_JOB_ON_INPUT_STEP = "ALLOW_SAVING_JOB_ON_INPUT_STEP";
export const SET_JOB_SAVED = "SET_JOB_SAVED";
export const SET_FOOTER_INFO_BUTTON_TEXT = "SET_FOOTER_INFO_BUTTON_TEXT";
export const setLoading = (isLoading, faradayLoading = false) => ({
  type: SET_LOADING,
  payload: {isLoading, faradayLoading}
});
export const expandFooterInfo = (footerInfoExpanded = false) => ({
  type: EXPAND_FOOTER_INFO,
  payload: {footerInfoExpanded}
});
export const setFooterInfoButtonText = (footerInfoButtonText = "") => ({
  type: EXPAND_FOOTER_INFO,
  payload: {footerInfoButtonText}
});
export const setLeadPopup = (leadPopup) => ({
  type: SET_LEAD_POPUP,
  payload: leadPopup
});

export const setJobSaved = (jobData) => ({
  type: SET_JOB_SAVED,
  payload: jobData
});

export const setAllowJobSavingOnInputStep = () => ({
  type: ALLOW_SAVING_JOB_ON_INPUT_STEP,
});

const someUserInfoIsDifferent = (userInfo, registeredUser) => {
  return Object.keys(registeredUser).some(key => registeredUser[key] !== userInfo[key])
}

export const saveJobAction = (isDelayedSave = false) => {
  return async (dispatch, getState) => {
    const store = getState();
    const {appointmentDate} = store.appointmentState;
    const {userInfo, registeredUser} = store.userState;

    if (!userInfo.isLoggedIn) {
      // 1) register user
      const registered = await registerUser(store);
      console.log("registered", registered);
      if (registered && registered.data) {
        dispatch(setRegisteredUserData(registered.data.email, registered.data.authToken));
      }
      dispatch(setUserInfo("isLoggedIn", true));
    } else if (someUserInfoIsDifferent(userInfo, registeredUser)) {
      // 1.5) update user info
      const updatedCustomer = await updateUser(store);
      if (updatedCustomer && updatedCustomer.data && updatedCustomer.data.success) {
        dispatch(setRegisteredUserData(store.userState.userInfo.email, updatedCustomer.data.token));
      }
    }

    // 2) save job
    // getState() needed here to have registered email
    const saveJobResponse = await postSaveJob(getSaveJobData(getState(), isDelayedSave));

    if (!saveJobResponse || !saveJobResponse.data) {
      console.error("job wasn't saved", saveJobResponse);
      return
    }

    // 3) set appointment
    if (appointmentDate && saveJobResponse.data.jobId) { // check fab setting here if needed
      await postScheduleAppointment(getSaveAppointmentData(store, saveJobResponse.data.jobId));
    }

    dispatch(setJobSaved({jobId: saveJobResponse.data.jobId}));
  }
}

// if (registered.data && registered.data.isEmailTaken && registered.data.errorUserMatch) {
//   visitContextDispatch(visitContextAction({
//     popup: Object.assign({}, visitContextState.popup, {
//       visible: true,
//       text: "This email already exists in the system. Would you like to add your quote to this customer?",
//       buttons: [{
//         text: "No",
//         onClick: () => {
//           visitContextDispatch(visitContextAction({
//             popup: Object.assign({}, visitContextState.popup, {visible: false})
//           }));
//         }
//       }, {
//         text: "Yes",
//         onClick: () => {
//           // here we can take some info from already registered user
//           visitContextDispatch(visitContextAction({
//             popup: Object.assign({}, visitContextState.popup, {visible: false})
//           }));
//           visitContextDispatch(visitContextChangeFormAction("isLoggedIn", true, "contact"));
//           switchToAppointmentPage();
//         }
//       }],
//     })
//   }))
//   return false
// }
